import { useMemo } from 'react';
import {
  Breakpoints,
  Button,
  ButtonSize,
  ButtonStyles,
  ButtonWidth,
  Drawer,
  useBreakpoint,
  useTranslation,
} from '@nextgen-web-framework/all';
import { FacetsDrawerProps } from './types/propTypes';
import styles from './Facets.module.scss';

const FacetsDrawer = ({
  children,
  isApplyBtnDisabled,
  isResetBtnDisabled,
  onApply,
  onClose,
  onReset,
}: FacetsDrawerProps) => {
  const t = useTranslation();
  const viewport = useBreakpoint() as Breakpoints;
  const buttonSize = useMemo(
    () => ([Breakpoints.XS, Breakpoints.SM].includes(viewport) ? ButtonSize.SMALL : ButtonSize.MEDIUM),
    [viewport],
  );

  return (
    <Drawer
      header={t('search.common.sortAndFilter')}
      closeIcon
      className={styles['facets-drawer']}
      onClose={onClose}
      bottomGap={0}
      footer={
        <div className={styles['facets-drawer-footer']}>
          <Button
            title={t('search.common.clearAll')}
            data-testid="facet-reset-testid"
            buttonStyle={ButtonStyles.OUTLINE}
            size={buttonSize}
            buttonWidth={ButtonWidth.FULL_WIDTH}
            disabled={isResetBtnDisabled}
            onClick={onReset}
          />
          <Button
            title={t('search.facets.ApplyBtn')}
            data-testid="facet-apply-testid"
            buttonStyle={ButtonStyles.SOLID}
            size={buttonSize}
            buttonWidth={ButtonWidth.FULL_WIDTH}
            disabled={isApplyBtnDisabled}
            onClick={onApply}
          />
        </div>
      }
    >
      {children}
    </Drawer>
  );
};

export default FacetsDrawer;
